export const stakeHoldersData = [{
    id: '9101',
    holderName: 'William Joy',
    email: 'William@example.com',
    numberOfShares: '120',
    valueOfInvestment: '$120000',
  },
  {
    id: '9102',
    holderName: 'Thomas Arin',
    email: 'Thomas@example.com',
    numberOfShares: '24',
    valueOfInvestment: '$4000',
  },
  {
    id: '9103',
    holderName:  'James Smith',
    email: 'James@example.com',
    numberOfShares: '55',
    valueOfInvestment: '$400000',
  },
  {
    id: '9104',
    holderName: 'James Johnson',
    email: 'Johnson@example.com',
    numberOfShares: '200',
    valueOfInvestment: '$1000',
  },
  {
    id: '9105',
    holderName:  'Maria Hernandez',
    email: 'Hernandez@example.com',
    numberOfShares: '300',
    valueOfInvestment: '$24000',
  }
  ]